export const call = (func, payload)=>{
    return {
        __type: 'call',
        func,
        args: [
            payload
        ]
    };
};
